module.exports = __webpack_public_path__ + "static/img/download-apple.00e3539.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download-apple.svg
// module id = T4Aw
// module chunks = 1